import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { KostDataImportTargetConfig } from './target-config';
import { KostDataImportProcessData } from '../import-process';
import { VirtualClinicKostNewVirtualClinicComponent } from './virtual-clinic';
import { VirtualClinicKostNewTermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

@Component({
  selector: 'kost-data-import-new-target',
  template: `
    <div>
      <div class="">
        <span class="text-sm font-medium" i18n
          >Wählen Sie aus für welche Virtuelle Klinik die Daten importiert
          werden sollen</span
        >
      </div>
      <ays-virtual-clinic-kost-new-virtual-clinic
        [virtualClinicId]="processData.virtualClinicId"
        [virtualClinicSelectOptions]="config.virtualClinicSelectOptions"
        [resourceName]="config.resourceName"
        (virtualClinicIdChange)="onVirtualClinicIdChange($event)"
      >
      </ays-virtual-clinic-kost-new-virtual-clinic>
    </div>

    <div>
      <kost-data-import-new-target-terms-and-conditions
        [config]="config.termsAndConditions"
        [acceptedTermsAndConditions]="processData.acceptedTermsAndConditions"
        (acceptedTermsAndConditionsChange)="
          onAcceptedTermsAndConditionsChange($event)
        "
      >
      </kost-data-import-new-target-terms-and-conditions>
    </div>
  `,
  styles: ``,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    VirtualClinicKostNewVirtualClinicComponent,
    VirtualClinicKostNewVirtualClinicComponent,
    VirtualClinicKostNewTermsAndConditionsComponent,
  ],
})
export class KostDataImportNewTargetComponent {
  @Input()
  public config: KostDataImportTargetConfig;

  @Input()
  public processData: KostDataImportProcessData;

  public readonly update = output<{
    data: KostDataImportProcessData;
    complete: boolean;
  }>();

  public onVirtualClinicIdChange(virtualClinicId: string) {
    this.processData.virtualClinicId = virtualClinicId;
    this._emitUpdate();
  }

  public onAcceptedTermsAndConditionsChange(checked: boolean) {
    this.processData.acceptedTermsAndConditions = checked;
    this._emitUpdate();
  }

  private _emitUpdate(): void {
    this.update.emit({
      data: this.processData,
      complete: this._isComplete(),
    });
  }

  private _isComplete(): boolean {
    return (
      !!this.processData.virtualClinicId &&
      this.processData.acceptedTermsAndConditions
    );
  }
}
